var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(.417 .417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.583c0-.92-.746-1.666-1.667-1.666h-1.051a6.64 6.64 0 0 0-.71-1.715l.743-.744a1.666 1.666 0 1 0-2.357-2.356l-.743.743a6.64 6.64 0 0 0-1.715-.71V2.083a1.667 1.667 0 0 0-3.333 0v1.052a6.64 6.64 0 0 0-1.715.71l-.744-.743a1.666 1.666 0 1 0-2.356 2.356l.743.744a6.64 6.64 0 0 0-.71 1.715H2.083a1.667 1.667 0 0 0 0 3.333h1.052a6.64 6.64 0 0 0 .71 1.715l-.743.743a1.666 1.666 0 1 0 2.356 2.357l.744-.743c.529.312 1.105.552 1.715.71v1.051a1.667 1.667 0 0 0 3.333 0v-1.051a6.64 6.64 0 0 0 1.715-.71l.743.743a1.666 1.666 0 1 0 2.357-2.357l-.743-.743c.312-.53.552-1.105.71-1.715h1.051c.92 0 1.667-.746 1.667-1.667z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.583,
    cy: 9.583,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsGrey);
export default __webpack_public_path__ + "static/media/settings-grey.950341755f1d5ddb4d8465dd2763e3f7.svg";
export { ForwardRef as ReactComponent };